import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getActiveSurvey, getMyResponse, submitResponse } from '@/services/api/surveys'

export function useActiveSurvey(enabled = true) {
  return useQuery({
    queryKey: ['surveys', 'active'],
    queryFn: getActiveSurvey,
    enabled,
    retry: false,
  })
}

export function useMyResponse(surveyId: string | undefined) {
  return useQuery({
    queryKey: ['surveys', surveyId, 'my-response'],
    queryFn: () => getMyResponse(surveyId!),
    enabled: !!surveyId,
    retry: false,
  })
}

export function useSubmitResponse() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      surveyId,
      likertAnswers,
      freeTextAnswer,
    }: {
      surveyId: string
      likertAnswers: Record<string, number>
      freeTextAnswer: string
    }) => submitResponse(surveyId, { likertAnswers, freeTextAnswer }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['surveys', variables.surveyId, 'my-response'] })
    },
  })
}
